import { SET_BUSINESS_APPOINTMENTS_TYPE } from '../../../actions/businessAppointments';
import { TActions } from '../../../types/actions';
import { TBusinessAppointmentsState } from '../../../types/businessType';

export const initialState: TBusinessAppointmentsState = {
  isLoaded: false,
  data: null,
};

export function businessAppointmentsReducer(state = initialState, action: TActions): TBusinessAppointmentsState {
  switch (action.type) {
    case SET_BUSINESS_APPOINTMENTS_TYPE:
      return {
        ...state,
        isLoaded: true,
        data: action.payload,
      };
  }

  return state;
}
